import {workflowsDimension} from '@packages/systems/designer/workflows-dimension';
import {abilityFeature} from '../abilityFeature';

export const workflows = abilityFeature({
  key: 'workflows',
  isValid: function isWorkflowsValid(state, config) {
    return workflowsDimension.isValid(state, config);
  },
});
